// extracted by mini-css-extract-plugin
export var sliderRange = "_po-2";
export var sliderRoot = "_po-0";
export var sliderThumb = "_po-3";
export var sliderTrack = "_po-1";